import { Injectable, Pipe , PipeTransform} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'sanitize'
})

@Injectable()
export class SanitizePipe implements PipeTransform{
    constructor(private dom:DomSanitizer) { }

    transform(value: string, args:object) {
        return this.dom.bypassSecurityTrustHtml(value);
    }
}
